import React from 'react';
import { Tree } from 'antd';
import { stringMixin } from "../../utils/strings";

import "./PortfolioTree.css";

const PortfolioTree = ({ tree }) => {
  // Recursive function to transform the data structure into Ant Tree nodes
  const transformToTreeData = (node, cumulativeWeight = 1, depth = 0, key = '') => {
    // If node is undefined or null, return empty
    if (!node) return null;

    return (
      Object.entries(node)
        // Sort the items based on weight (wgt) in descending order
        .sort(([, a], [, b]) => (b.wgt ?? 0) - (a.wgt ?? 0))
        .map(([id, subNode]) => {
          const weight = subNode.wgt ?? 0;
          // Calculate the pro-rated weight (weight * cumulativeWeight from parent)
          const proratedWeight = weight * cumulativeWeight;

          const title = subNode.name
            ? `${subNode.name} ${stringMixin.pct(weight)} ( ${stringMixin.pct(proratedWeight)} )`
            : 'Unknown';

          // Define dynamic styles based on depth
          const fontSize = Math.max(16 - depth * 2, 10); // Decrease by 2px per level, with a minimum of 10px
          const isLastLevel = !subNode.tree || Object.keys(subNode.tree).length === 0;
          const nodeStyle = {
            opacity: weight === 0 ? 0.5 : 1,
            padding: '10px 0',
            fontSize: `${fontSize}px`,
            fontWeight: isLastLevel ? 'bold' : 'normal',
            textTransform: isLastLevel ? 'uppercase' : 'none',
          };

          return {
            title: <span style={nodeStyle}>{title}</span>,
            key: `${key}-${id}`,
            // Pass the cumulative weight to children (proratedWeight becomes the new cumulative weight)
            children: subNode.tree ? transformToTreeData(subNode.tree, proratedWeight, depth + 1, `${key}-${id}`) : [],
          };
        })
    );
  };

  // Convert the tree object into a format suitable for the Ant Design Tree component
  const treeData = transformToTreeData(tree);

  return (
    <div className="tree-container">
      <Tree
        treeData={treeData}
        defaultExpandAll
      />
    </div>
  );
};

export default PortfolioTree;
